const bindDictionaryItemsToReactJsonSchemaForm = (source, schemaProperties) => {
  Object.keys(schemaProperties).forEach((propertyName) => {
    if (schemaProperties[propertyName].type === 'object') {
      bindDictionaryItemsToReactJsonSchemaForm(source, schemaProperties[propertyName].properties);
    } else {
      if (propertyName === source.name) {
        const oneOfValues = source?.items?.map?.((dictionaryItem) => ({ const: dictionaryItem.id, title: dictionaryItem.value })) || [];

        if (schemaProperties[propertyName].type === 'array') {
          schemaProperties[propertyName].items = { type: 'string', oneOf: oneOfValues };
          schemaProperties[propertyName].uniqueItems = true;
        } else {
          schemaProperties[propertyName].oneOf = oneOfValues;
        }
      }
    }
  });
};

export default (definition, sources) => {
  const schemaElements = definition ? definition.split('|') : null;
  const schemaObject = schemaElements ? JSON.parse(schemaElements[0]) : null;
  const uiSchemaObject = schemaElements ? JSON.parse(schemaElements[1]) : null;

  if (sources && sources.length > 0) {
    sources.forEach((source) => {
      bindDictionaryItemsToReactJsonSchemaForm(source, schemaObject.properties);
    });
  }

  return { schemaObject, uiSchemaObject };
};
